import React from 'react';
import ReactDOMClient from 'react-dom/client';
import {Provider } from 'react-redux';


import './root.scss';

import App from './App'; 
import { store } from './store';



//create root
const root = ReactDOMClient.createRoot(document.getElementById('root'));

//render
root.render( 
    <Provider store={store}>
       <App /> 
    </Provider>);